import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronRightSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.207 5.293a1 1 0 1 0-1.414 1.414L14.086 12l-5.293 5.293-.068.076a1 1 0 0 0 1.406 1.406l.076-.068 6-6a1 1 0 0 0 0-1.414z"
    />
  </svg>
);
export default SvgChevronRightSmall;
